<template>
    <div v-if="eventsLoaded || accountTypeIsPro">
        <section class="row">
            <div class="col-lg-12 last-examination__wrapper">
                <h3 class="title-content">{{ $t('WELCOME_NAME', { name: user.firstName, id: user.id }) }}</h3>
            </div>
        </section>
        <section class="row mb-5">
            <div class="col-xs-12 col-md-6 last-examination__wrapper" v-if="lastExamination">
                <h3 class="title-content">{{ $t('LAST_EXAMINATION') }}:</h3>
                <div class="last-examination__section">
                    <div class="calendar__info__date__wrapper calendar__info__date__wrapper--gray">
                        {{ lastExamination.isoDate | moment('ddd') }}
                        <p class="date__day-number">{{ lastExamination.isoDate | moment('D') }}</p>

                        <div class="calendar__info__month">{{ lastExamination.isoDate | moment('MMM YYYY') }}</div>
                    </div>

                    <div class="app-box">
                        <strong style="font-size: 20px">
                            {{
                                lastExaminationCanBeDisplayed
                                    ? $t('EXAMINATION_ALREADY_AVAILABLE')
                                    : lastExaminationNeedsToComplete
                                    ? $t('EXAMINATION_NEEDS_DATA')
                                    : $t('WAITING_FOR_RESULT')
                            }}
                        </strong>
                        <button
                            @click="displayExaminationDetails(lastExamination)"
                            :class="
                                lastExaminationCanBeDisplayed
                                    ? 'app-btn app-btn--big app-btn-primary btn-check-result'
                                    : 'app-btn app-btn--big app-btn-default'
                            "
                        >
                            {{ $t('CHECK_IT') }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-6 last-examination__wrapper" v-else>
                <h3 class="title-content">{{ $t('LAST_EXAMINATION') }}:</h3>
                <div class="last-examination__section">
                    <div class="app-box app-box--content">
                        <strong style=" font-size: 20px; font-weight: 700;">{{ $t('NO_DATA_AVAILABLE') }}</strong>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-6">
                <h3 class="title-content">{{ $t('FOR_USE') }}</h3>

                <div class="row" style="padding-top: 20px" v-if="showActivationCodeInput">
                    <form>
                        <div class="form-group col-xs-12 col-md-8">
                            <div class="control">
                                <p
                                    v-if="errors.has('activation_code')"
                                    class="validate-danger"
                                    style="position: absolute; top: -30px;"
                                >
                                    <img src="./../../../assets/images/icons/excl-red.svg" />
                                    {{ $t('INVALID_CODE_INSERTED') }}
                                </p>
                                <p
                                    v-else-if="activationCodeErrorInfo"
                                    class="validate-danger"
                                    style="position: absolute; top: -30px;"
                                >
                                    <img src="./../../../assets/images/icons/excl-red.svg" />
                                    {{ activationCodeErrorInfo }}
                                </p>
                                <input
                                    v-model="activationCode"
                                    type="text"
                                    class="text-input -white-input"
                                    name="activation_code"
                                    :class="{ validate: activationCodeIsInValid }"
                                    :placeholder="$t('CODE_PLACEHOLDER')"
                                />
                                <button
                                    @click.prevent="showActivationCodeInput = false"
                                    style="text-decoration: none;margin-top: 5px; color: #CF004A;width: 100%; text-align: right;"
                                    class="log-reg-form__remind-password"
                                >
                                    {{ $t('CANCEL') }}
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-4">
                            <button class="app-btn app-btn--big app-btn-primary" @click.prevent="activatePackage">
                                {{ $t('ACTIVATE') }}
                            </button>
                        </div>
                    </form>
                </div>

                <div v-else>
                    <div class="package-section">
                        <div style="display: block;">
                            <strong style="font-size: 18px">{{ $t('EXAMINATIONS') }}</strong>
                            <strong style="font-size: 20px; margin-left: 5px">{{
                                thousandsSeparator(availableStocks)
                            }}</strong>
                            <div v-if="availableStocksTest != 0" style="display: block;">
                                <strong style="font-size: 16px">{{ $t('TEST_EXAMINATIONS') }}</strong>
                                <strong style="font-size: 20px; margin-left: 5px">{{
                                    thousandsSeparator(availableStocksTest)
                                }}</strong>
                            </div>
                        </div>

                        <!--<span style="font-size: 25px; margin: 0 10px 0 10px">({{ $t('OF') }} {{ maxStocks }})</span>-->
                        <!-- <el-tooltip
                            v-if="lastStockExpirationDate != ''"
                            class="item"
                            style="margin-left: 10px"
                            effect="light"
                            :content="
                                $t('EXAMINATIONS_AVAILABLE_TOOLTIP', {
                                    available: this.availableStocks,
                                    max: maxStocks,
                                }) +
                                    ' ' +
                                    $t('PACKAGE_VALID_UNTIL') +
                                    ' ' +
                                    lastStockExpirationDate
                            "
                            placement="top"
                        >
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-tooltip
                            v-else
                            class="item"
                            effect="light"
                            :content="
                                $t('EXAMINATIONS_AVAILABLE_TOOLTIP', {
                                    available: this.availableStocks,
                                    max: maxStocks,
                                })
                            "
                            placement="top"
                        >
                            <i class="el-icon-question"></i>
                        </el-tooltip>-->
                        <button
                            class="app-btn app-btn--big app-btn-default btn-buy-package"
                            @click="buyAnotherPackage"
                            :disabled="!userShopUrl"
                            :class="{ 'btn-hover-disable': !userShopUrl }"
                        >
                            {{ $t('BUY_PACKAGE') }}
                        </button>
                    </div>

                    <div style="text-align: center;">
                        <span>{{ $t('YOU_HAVE_ALREADY_ACTIVATION_CODE') }}</span>
                        <br />
                        <button
                            @click="showActivationCodeInput = true"
                            style="text-decoration: none; color: #CF004A;"
                            class="log-reg-form__remind-password"
                        >
                            {{ $t('ACTIVATE_PACKAGE') }}
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="row" v-if="!accountTypeIsPro">
            <div class="col-xs-12">
                <h3 class="title-content">{{ $t('NEXT_EXAMINATION_POSSIBLE') }}</h3>
                <div class="row">
                    <!-- CALENDAR -->
                    <div class="col-xs-12 col-sm-7">
                        <vue-calendar
                            :first-day="1"
                            :events="events"
                            @dayClicked="dayClicked"
                            @eventClicked="eventClicked"
                            @monthChanged="monthChanged"
                        ></vue-calendar>
                    </div>

                    <!--braster allowed component-->
                    <braster-allowed
                        :firstPeriodDay="firstPeriodDay"
                        :firstAllowedDay="firstAllowedDay"
                        :lastAllowedDay="lastAllowedDay"
                        v-if="brasterAllowed"
                        @showVideo="showVimeo"
                    ></braster-allowed>
                    <section class="col-xs-12 col-sm-5 hide" v-if="brasterAllowedState">
                        <div class="calendar__info">
                            <div class="calendar__info__item">
                                <h4 class="calendar__info__title">{{ $t('FIRST_PERIOD_DAY') }}</h4>
                                <div class="calendar__info__date__wrapper">
                                    <div class="calendar__info__date">
                                        <span>{{ firstPeriodDay | moment('dd') }}</span>
                                        <span class="date__day-number">{{ firstPeriodDay | moment('DD') }}</span>
                                    </div>
                                    <div class="calendar__info__month">
                                        <span>
                                            {{ firstPeriodDay | moment('MMM') }}
                                            {{ firstPeriodDay | moment('YYYY') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="calendar__info__tooltip">
                                    {{ $t('FIRST_PERIOD_DAY_INFO') }}
                                    <!--<strong>{{ $t('CLICK_CALENDAR')}}</strong>-->
                                </div>
                            </div>
                        </div>
                    </section>

                    <!--braster disallowed information-->
                    <braster-disallowed v-if="isDisallowed"></braster-disallowed>

                    <!--first period day section-->
                    <section class="col-xs-12 col-sm-5" v-if="firstPeriodDaySection">
                        <div class="calendar__info">
                            <div class="calendar__info__item">
                                <h4 class="calendar__info__title">{{ $t('FIRST_PERIOD_DAY') }}</h4>
                                <div class="calendar__info__date__wrapper">
                                    <div class="calendar__info__date">
                                        <span>{{ firstPeriodDay | moment('dd') }}</span>
                                        <span class="date__day-number">{{ firstPeriodDay | moment('DD') }}</span>
                                    </div>
                                    <div class="calendar__info__month">
                                        <span>
                                            {{ firstPeriodDay | moment('MMM') }}
                                            {{ firstPeriodDay | moment('YYYY') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="radio__wrapper">
                                    <v-radio-group
                                        v-model="isFirstPeriodDay"
                                        class="input-date-wrapper"
                                        @change="updateIsFirstPeriodDay"
                                    >
                                        <v-radio :label="$t('YES')" color="red darken-3" :value="true"></v-radio>
                                    </v-radio-group>
                                    <v-radio-group
                                        v-model="isFirstPeriodDay"
                                        class="input-date-wrapper"
                                        @change="updateIsFirstPeriodDay"
                                    >
                                        <v-radio :label="$t('NO')" color="red darken-3" :value="false"></v-radio>
                                    </v-radio-group>
                                </div>
                            </div>
                            <div class="calendar__info__item" v-if="cycleLengthSection">
                                <div class="next-examination__wrapper">
                                    <h4 class="calendar__info__title --no-border mb-1">{{ $t('CYCLE_LENGTH') }}</h4>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <el-select v-model="cycleLength" :placeholder="$t('SELECT')" disabled>
                                                <el-option :label="cycleLength" :value="cycleLength"></el-option>
                                            </el-select>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-6">
                                            <button
                                                @click.stop="confirmFirstPeriodDay"
                                                class="app-btn app-btn--big app-btn-primary --wild mt-3"
                                            >
                                                {{ $t('APPLY') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div class="col-xs-12 col-sm-5" v-if="lastPeriodSection">
                        <div class="calendar__info">
                            <div class="calendar__info__item" v-if="lastPeriodDaySection">
                                <h4 class="calendar__info__title">{{ $t('LAST_PERIOD') }}</h4>
                                <div class="calendar__info__date__wrapper">
                                    <div class="calendar__info__date">
                                        <span>{{ lastPeriodDay | moment('dd') }}</span>
                                        <span class="date__day-number">{{ lastPeriodDay | moment('DD') }}</span>
                                    </div>
                                    <div class="calendar__info__month">
                                        <span>
                                            {{ lastPeriodDay | moment('MMM') }}
                                            {{ lastPeriodDay | moment('YYYY') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="calendar__info__tooltip">
                                    {{ $t('FIRST_PERIOD_DAY_INFO') }}
                                    <!--<strong>{{ $t('CLICK_CALENDAR')}}</strong>-->
                                </div>
                            </div>
                            <div class="calendar__info__item" v-if="lastExaminationSection && lastExamination">
                                <div class="next-examination__wrapper">
                                    <h4 class="calendar__info__title">{{ $t('LAST_BRASTER_EXAMINATION') }}:</h4>

                                    <div class="next-examination__legend next-examination__legend--transparent">
                                        <img class="legend-img" src="../../../assets/images/braster-logo-app.png" />
                                    </div>

                                    <div class="next-examination__date">{{ dateFormat(lastExamination.isoDate) }}</div>
                                </div>
                            </div>
                            <div class="calendar__info__item" v-if="nextExaminationSection">
                                <div class="next-examination__wrapper">
                                    <h4 class="calendar__info__title">{{ $t('NEXT_BRASTER_EXAMINATION') }}:</h4>

                                    <div class="next-examination__legend"></div>

                                    <div class="next-examination__date" v-if="firstAllowedDay && lastAllowedDay">
                                        <template v-if="todayIsLastAllowedForecast">
                                            {{ dateFormat(firstAllowedDayIfTodayIsLastPeriodForecast) }}-{{
                                                dateFormat(lastAllowedDayIfTodayIsLastPeriodForecast)
                                            }}
                                        </template>
                                        <template v-else
                                            >{{ dateFormat(firstAllowedDay) }}-{{
                                                dateFormat(lastAllowedDay)
                                            }}</template
                                        >

                                        <a style="cursor: pointer" class="trigger" @click="showVimeo()">
                                            {{ $t('HOW_TO_MAKE_EXAMINATION') }}
                                            <img class="link-img" src="/src/assets/images/arrow-red.png" />
                                        </a>
                                    </div>

                                    <div class="next-examination__date" v-else>
                                        <span class="trigger">{{ $t('SELECT_DATE_FROM_CALENDAR') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--MODAL BUY PACKAGE-->
        <app-modal v-if="showModal" @close="closeModal">
            <app-buy-package @buy="buyAnotherPackage" @close="closeModal"></app-buy-package>
        </app-modal>

        <!--MODAL CHECK IF DATA ARE UP TO DATE-->
        <app-modal v-if="!accountTypeIsPro && checkMyDataModal" @close="updateLastQuestionedDay">
            <check-your-data @gotomydata="goToMyData" @close="updateLastQuestionedDay"></check-your-data>
        </app-modal>

        <!--MODAL BRASTER VIMEO VIDEO-->
        <app-modal v-if="showVimeoModal" @close="closeModal">
            <what-is-braster></what-is-braster>
        </app-modal>

        <!--MODAL BRASTER TERMS AGREEMENT-->
        <terms-agreement v-if="!checkAgreementStatus" @agree="closeTermsModal" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Modal from '../../modals/_modal.vue';
import CheckYourData from '../../modals/are-you-up-to-date.vue';
import BuyPackage from '../../modals/buy-package.vue';
import BrasterAllowed from '../../period-modules/braster-allowed.vue';
import BrasterDisallowed from '../../period-modules/braster-disallowed.vue';
import FirstPeriodDay from '../../period-modules/first-period-day.vue';
import LastPeriodAndExaminationDay from '../../period-modules/last-period-and-examination.vue';
import WhatIsBraster from './../../shared/what-is-braster/what-is-braster.vue';
import { config, eventBus } from './../../../main';
import { examinationNeedsToComplete, examinationCanBeDisplayed } from '../../../assets/js/examinationUtils';
import TermsAgreement from '../../modals/termsAgreement.vue';

export default {
    data() {
        return {
            showModal: false, // buy package modal
            showVimeoModal: false, // show vimeo modal
            showTermsModal: true,
            brasterAllowed: false,
            isFirstPeriodDay: '',
            lastStockExpirationDate: null,
            firstPeriodDaySection: false,
            lastPeriodSection: true, // if we show last period day section
            cycleLengthSection: false,
            selectedMonthIsCurrentMonth: true,
            events: [],
            oldEvents: [],
            firstPeriodDayBackup: null,
            survey: {},
            isDisallowed: false,
            isBuyForWoman: false,
            eventsLoaded: false,
            activationCode: '',
            showActivationCodeInput: false,
            availableStocks: 0,
            availableStocksTest: 0,
            maxStocks: 0,
            activationCodeErrorInfo: '',
            firstAllowedDayIfTodayIsLastPeriodForecast: '',
            lastAllowedDayIfTodayIsLastPeriodForecast: '',
            periodLengthForMenstruatingIrregularlyAndNotMenstruating: 30,
            numberOfDaysAfterWhatCheckMyDataModalWillBeDisplayed: 30,
        };
    },
    computed: {
        ...mapState(['user', 'examinations']),
        ...mapGetters(['accountTypeIsPro', 'userShopUrl']),
        lastExamination() {
            return this.examinations[0];
        },
        lastExaminationCanBeDisplayed() {
            return examinationCanBeDisplayed(this.lastExamination);
        },
        lastExaminationNeedsToComplete() {
            return examinationNeedsToComplete(this.lastExamination);
        },
        activationCodeIsInValid() {
            if (this.activationCode.length == 0) {
                return false;
            }
            if (this.activationCode.length != 19) {
                return true;
            }
            let charCode = '';
            for (var i = 0; i < this.activationCode.length; i++) {
                let char = this.activationCode.toUpperCase().charAt(i);
                if (this.is_numeric(char)) {
                    charCode = charCode + char;
                } else {
                    charCode = charCode + this.activationCode.toUpperCase().charCodeAt(i);
                }
            }

            return !this.valid_activation_code(charCode);
        },
        checkAgreementStatus() {
            const terms = this.user.userAgreements.find(element => element.agreement.label == 'TERMS');
            // console.log(terms.agreed)

            return terms.agreed;
        },
        firstPeriodDay: {
            get() {
                return this.$moment(this.survey.nextVisit)
                    .subtract(2, 'days')
                    .format('YYYY-MM-DD');
            },
            set(newValue) {
                this.survey.nextVisit = this.$moment(newValue)
                    .add(2, 'days')
                    .format('YYYY-MM-DD');
            },
        },
        lastPeriodDay() {
            return this.survey.dateOfLastMenstruation;
        },
        cycleLength() {
            return this.$moment(this.firstPeriodDay).diff(this.$moment(this.lastPeriodDay), 'days');
        },
        firstAllowedDay() {
            return this.survey.nextVisit;
        },
        lastAllowedDay() {
            return this.$moment(this.firstAllowedDay)
                .add(9, 'days')
                .format('YYYY-MM-DD');
        },
        isMenstruating() {
            return this.survey.hasMenstruation;
        },
        brasterAllowedState() {
            return this.$store.getters.brasterAllowed;
        },
        lastPeriodDaySection() {
            if (this.isBuyForWoman) {
                return false;
            } else if (!this.isDisallowed && this.isMenstruating) {
                return true;
            } else {
                return false;
            }
        },
        lastExaminationSection() {
            if (this.isBuyForWoman) {
                return false;
            } else if (!this.isDisallowed && this.isMenstruating && !this.selectedMonthIsCurrentMonth) {
                return true;
            } else if (!this.isDisallowed && !this.isMenstruating) {
                return true;
            } else {
                return false;
            }
        },
        nextExaminationSection() {
            if (this.isBuyForWoman) {
                return false;
            } else if (!this.isDisallowed && this.isMenstruating && this.selectedMonthIsCurrentMonth) {
                return true;
            } else if (!this.isDisallowed && !this.isMenstruating) {
                return true;
            } else {
                return false;
            }
        },
        checkMyDataModal() {
            const today = this.$moment();
            const dateLastQuestioned = this.$moment(this.survey.dateLastQuestioned);
            const dayDifference = today.diff(dateLastQuestioned, 'days');
            return dayDifference > this.numberOfDaysAfterWhatCheckMyDataModalWillBeDisplayed && !this.accountTypeIsPro;
        },
        todayIsLastAllowedForecast() {
            const today = this.$moment();
            const firstAllowedDay = this.$moment(this.lastPeriodDay).add(2, 'days');
            if (today.diff(firstAllowedDay, 'days') <= 11) {
                return (
                    this.examinations.filter(i => this.$moment(new Date(i.isoDate)).isBetween(firstAllowedDay, today))
                        .length === 0
                );
            } else {
                return false;
            }
        },
        firstPeriodWasConfirmed() {
            return this.survey.next_period != null;
        },
    },
    methods: {
        ...mapActions(['fetchUser', 'fetchExaminations', 'fetchUserSurvey', 'updateUserSurvey']),
        activatePackage() {
            if (!this.activationCodeIsInValid) {
                this.$http.post('/user/api/profile/activatePackage', { code: this.activationCode }).then(response => {
                    if (response.body.status === '200') {
                        this.activationCode = '';
                        this.showActivationCodeInput = false;
                        this.activationCodeErrorInfo = '';
                        this.reloadStocks();
                    }

                    if (response.body.status === '400') {
                        if (response.body.statusCode === 'CODE_ALREADY_ASSIGNED')
                            this.activationCodeErrorInfo = this.$i18n.t('CODE_ALREADY_USED');
                        if (response.body.statusCode === 'CODE_EXPIRED')
                            this.activationCodeErrorInfo = this.$i18n.t('CODE_ALREADY_EXPIRED');
                        if (response.body.statusCode === 'NO_SUCH_CODE')
                            this.activationCodeErrorInfo = this.$i18n.t('INVALID_CODE_INSERTED');
                        if (response.body.statusCode === 'BAD_TERRITORY')
                            this.activationCodeErrorInfo = this.$i18n.t('BAD_ACCOUNT_TYPE');
                        if (response.body.statusCode === 'BAD_PRODUCT_LINE')
                            this.activationCodeErrorInfo = this.$i18n.t('BAD_ACCOUNT_TYPE');
                        if (response.body.statusCode === 'CODE_BLOCKED')
                            this.activationCodeErrorInfo = this.$i18n.t('INVALID_CODE_INSERTED');
                    }
                });
            }
        },
        monthChanged(start, end) {
            this.selectedMonthIsCurrentMonth =
                new Date().getYear() === end.getYear() && new Date().getMonth() === end.getMonth();
        },

        is_numeric(str) {
            return /^\d+$/.test(str);
        },

        dayClicked(event) {
            //this.displayForecastInCalendarForGivenDay(event.date);
        },

        valid_activation_code(value) {
            if (/[^0-9-\s]+/.test(value)) return false;

            let nCheck = 0,
                bEven = false;
            value = value.replace(/\D/g, '');

            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n),
                    nDigit = parseInt(cDigit, 10);

                if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

                nCheck += nDigit;
                bEven = !bEven;
            }
            return nCheck % 10 == 0;
        },

        displayForecastInCalendarForGivenDay(forecastedPeriodDate) {
            const today = this.$moment();
            const forecastedPeriod = this.$moment(forecastedPeriodDate);
            const lastPeriod = this.$moment(this.lastPeriodDay);
            if (
                this.isMenstruating &&
                !this.isDisallowed &&
                today.diff(forecastedPeriod, 'seconds') >= 0 &&
                forecastedPeriod.diff(lastPeriod, 'seconds') > 0
            ) {
                this.firstPeriodDayBackup = this.firstPeriodDay;
                this.firstPeriodDay = this.$moment(forecastedPeriodDate).format('YYYY-MM-DD');
                this.brasterAllowed = false;
                this.lastPeriodSection = false;
                this.firstPeriodDaySection = true;
                let temporaryEvents = [];
                temporaryEvents.push({
                    title: 'Mój event',
                    start: this.firstPeriodDay,
                    end: this.firstPeriodDay,
                    class: 'selected-period-day',
                });
                const firstAllowedDay = this.$moment(this.firstPeriodDay)
                    .add(2, 'days')
                    .format('YYYY-MM-DD');
                const lastAllowedDay = this.$moment(this.firstPeriodDay)
                    .add(11, 'days')
                    .format('YYYY-MM-DD');
                this.loadCurrentAllowedDaysToList(firstAllowedDay, lastAllowedDay, 'allowed-tmp-day').forEach(a =>
                    temporaryEvents.push(a),
                );
                this.events = temporaryEvents;
            }
        },
        confirmFirstPeriodDay() {
            this.updateUserSurvey({
                ...this.survey,
                nextMenstruation: this.firstPeriodDay,
                dateOfLastMenstruation: this.lastPeriodDay,
                hasMenstruation: true,
                menstruationDuration: this.cycleLength,
            }).then(() => {
                this.isFirstPeriodDay = '';
                this.cycleLengthSection = false;
                this.firstPeriodDaySection = false;
                this.lastPeriodSection = true;
                this.reloadCalendarData();
            });
        },
        displayExaminationDetails(examination) {
            if (examinationCanBeDisplayed(examination)) {
                this.$router.push({ name: 'szczegoly-badania', params: { id: examination.id } });
            } else {
                this.$router.push({ name: 'lista-wynikow' });
            }
        },
        eventClicked(event) {
            if (event['examinationId']) {
                const examinations = this.examinations
                    .filter(
                        a =>
                            this.$moment(a.isoDate).format('YYYY-MM-DD') ===
                            this.$moment(event.start).format('YYYY-MM-DD'),
                    )
                    .sort((a, b) => new Date(b.isoDate) - new Date(a.isoDate));
                this.displayExaminationDetails(examinations[0]);
            } else {
                //this.displayForecastInCalendarForGivenDay(event.start);
            }
        },
        closeModal() {
            this.showModal = false;
            this.showVimeoModal = false;
        },
        showVimeo() {
            this.showVimeoModal = true;
            this.$scrollTo('#app', 1000, { offset: 50 });
        },
        buyAnotherPackage() {
            if (this.userShopUrl) {
                window.open(this.userShopUrl).focus();
            }
        },
        goToMyData() {
            this.updateLastQuestionedDay().then(() => this.$router.push('/moje-dane'));
        },
        updateIsFirstPeriodDay() {
            if (this.isFirstPeriodDay === true) {
                this.cycleLengthSection = true;
            } else {
                this.isFirstPeriodDay = '';
                this.cycleLengthSection = false;
                this.lastPeriodSection = true;
                this.firstPeriodDaySection = false;
                this.brasterAllowed = false;
                this.events = this.oldEvents;
                this.firstPeriodDay = this.firstPeriodDayBackup;
            }
        },
        updateLastQuestionedDay() {
            return this.updateUserSurvey({
                ...this.survey,
                dateLastQuestioned: this.$moment().format('YYYY-MM-DD'),
            }).then(data => (this.survey = data));
        },
        updateEventsList(periods, allowedDays, examinations) {
            let temporary = [];
            examinations.forEach(a => temporary.push(a));
            allowedDays.forEach(a => temporary.push(a));
            periods.forEach(a => temporary.push(a));
            this.events = temporary;
            this.oldEvents = this.events;
            this.eventsLoaded = true;
        },
        loadCurrentAllowedDaysToList(firstDay, lastDay, className) {
            let allowedDays = [];
            while (this.$moment(lastDay).diff(this.$moment(firstDay), 'days') >= 0) {
                allowedDays.push({
                    title: 'W tych dniach można się badać',
                    start: firstDay,
                    end: firstDay,
                    class: className,
                });
                firstDay = this.$moment(firstDay)
                    .add(1, 'days')
                    .format('YYYY-MM-DD');
            }
            return allowedDays;
        },
        loadForecastedAllowedDaysAndPeriods() {
            let allowedDays = [];
            const cycleLength = this.cycleLength
                ? this.cycleLength
                : this.periodLengthForMenstruatingIrregularlyAndNotMenstruating;
            if (cycleLength > 11) {
                let temporaryDay = this.$moment(this.firstPeriodDay)
                    .add(cycleLength, 'days')
                    .format('YYYY-MM-DD');
                for (let i = 0; i < 36; i++) {
                    if (this.isMenstruating) {
                        allowedDays.push({
                            title: 'Dzień pierwszej miesiączki',
                            start: temporaryDay,
                            end: temporaryDay,
                            class: 'period-day-prediction',
                        });
                    }
                    allowedDays.push({
                        title: 'W tych dniach można się badać',
                        start: this.$moment(temporaryDay)
                            .add(2, 'days')
                            .format('YYYY-MM-DD'),
                        end: this.$moment(temporaryDay)
                            .add(11, 'days')
                            .format('YYYY-MM-DD'),
                        class: 'allowed-tmp-day',
                    });
                    temporaryDay = this.$moment(temporaryDay)
                        .add(cycleLength, 'days')
                        .format('YYYY-MM-DD');
                }
            }
            return allowedDays;
        },
        reloadCalendarData() {
            let periods = [];
            let allowedDays = [];
            let examinations = [];
            if (!this.isDisallowed && !this.buyForWomen) {
                this.fetchUserSurvey().then(data => {
                    this.survey = data;
                    if (this.isMenstruating) {
                        this.$http.get('/examination/api/other/survey/periods/').then(response => {
                            response.body.forEach(period => {
                                periods.push({
                                    title: 'Dzień pierwszej miesiączki',
                                    start: period.menstruationDate,
                                    end: period.menstruationDate,
                                    class: 'last-period-day',
                                });
                            });
                            periods.push(
                                {
                                    title: 'Dzień pierwszej miesiączki',
                                    start: this.lastPeriodDay,
                                    end: this.lastPeriodDay,
                                    class: 'last-period-day',
                                },
                                {
                                    title: 'Dzień pierwszej miesiączki',
                                    start: this.firstPeriodDay,
                                    end: this.firstPeriodDay,
                                    class: this.firstPeriodWasConfirmed ? 'last-period-day' : 'period-day-prediction',
                                },
                            );
                        });
                    }

                    this.loadCurrentAllowedDaysToList(
                        this.firstAllowedDay,
                        this.lastAllowedDay,
                        this.firstPeriodWasConfirmed || !this.isMenstruating ? 'allowed-day' : 'allowed-tmp-day',
                    ).forEach(a => allowedDays.push(a));
                    this.loadForecastedAllowedDaysAndPeriods().forEach(a => allowedDays.push(a));

                    this.fetchExaminations().then(() => {
                        examinations = this.examinations.map(examination => ({
                            title: 'Ostatnie badanie Brasterem',
                            start: this.$moment(examination.isoDate).format('YYYY-MM-DD'),
                            end: this.$moment(examination.isoDate).format('YYYY-MM-DD'),
                            examinationId: examination.id,
                            class: 'last-examination-day',
                        }));

                        if (this.todayIsLastAllowedForecast) {
                            let temporaryDay = this.$moment(this.lastPeriodDay).add(2, 'days');
                            this.firstAllowedDayIfTodayIsLastPeriodForecast = this.$moment(this.lastPeriodDay)
                                .add(2, 'days')
                                .format('YYYY-MM-DD');
                            this.lastAllowedDayIfTodayIsLastPeriodForecast = this.$moment(this.lastPeriodDay)
                                .add(11, 'days')
                                .format('YYYY-MM-DD');
                            for (let i = 0; i < 10; i++) {
                                allowedDays.push({
                                    title: 'W tych dniach można się badać',
                                    start: this.$moment(temporaryDay).format('YYYY-MM-DD'),
                                    end: this.$moment(temporaryDay).format('YYYY-MM-DD'),
                                    class: 'allowed-day',
                                });
                                temporaryDay = this.$moment(temporaryDay)
                                    .add(1, 'days')
                                    .format('YYYY-MM-DD');
                            }
                        }

                        this.updateEventsList(periods, allowedDays, examinations);
                    });
                });
            } else {
                this.updateEventsList(periods, allowedDays, examinations);
            }
        },
        reloadStocks() {
            this.$http.get('/user/api/profile/stockPackage').then(({ data: { examination, test } }) => {
                this.availableStocks = examination.actual;
                this.availableStocksTest = test.actual;
                this.maxStocks = examination.max;
            });
        },
        reloadLastStockExpirationDate() {
            this.$http.get('/user/api/profile/lastTokenExpirationDate/').then(response => {
                this.lastStockExpirationDate = response.bodyText;
            });
        },
        reloadEverything() {
            this.fetchUser();
            this.reloadLastStockExpirationDate();
            this.reloadStocks();
            this.reloadCalendarData();
        },
        closeTermsModal() {
            this.$http.get('/user/api/profile/user').then(({ data }) => {
                let agreements = data.userAgreements;
                agreements.forEach(agreement => {
                    if (agreement.agreement.label === 'TERMS') {
                        agreement.agreed = true;
                    }
                });
                const terms = this.user.userAgreements.find(element => element.agreement.label == 'TERMS');
                terms.agreed = true;
                this.$http.patch('/user/api/profile/user/agreements', agreements);
            });
        },

        //     const terms = this.user.userAgreements.find(element => element.agreement.label == 'TERMS');
        //     terms.agreed = true;
        //     this.$http.patch('/user/api/profile/user/agreements', [{ agreed: true, agreement: { label: 'TERMS' } }]);
        // },
    },
    components: {
        TermsAgreement,
        appModal: Modal,
        appBuyPackage: BuyPackage,
        CheckYourData,
        BrasterAllowed,
        BrasterDisallowed,
        FirstPeriodDay,
        LastPeriodAndExaminationDay,
        WhatIsBraster, //vimeo
    },
    mounted() {
        if (this.brasterAllowedState === false) {
            this.events = [];
        }
        eventBus.$on('reloadMyAccount', this.reloadEverything);
    },
    created() {
        if (this.accountTypeIsPro) {
            this.reloadLastStockExpirationDate();
            this.reloadStocks();
        } else {
            this.fetchUserSurvey().then(() => {
                const completionStage = this.$store.getters.survey.accountStage;
                this.isDisallowed = completionStage === 'DISALLOWED' || completionStage === 'DISALLOWED_AFTER_SURVEY';
                this.isBuyForWoman = completionStage === 'BUY_FOR_WOMEN';
                if (completionStage != null) {
                    this.reloadEverything();
                }
            });
        }
    },
};
</script>

<style lang="scss">
button {
    outline: none;
}

.package-section {
    align-items: center;
    display: flex;
    justify-content: flex-start;

    .app-btn {
        margin-left: auto;
    }
}

.btn-buy-package {
    min-width: 167px;
}

.btn-check-result {
    min-width: 127px;
}

.calendar__info {
    float: left;

    &__item {
        float: left;
        margin-bottom: 30px;
        margin-top: 10px;
        width: 100%;
    }

    &__title {
        color: #262626;
        font-size: 22px;
        font-weight: bold;
        padding-bottom: 15px;
        margin: 0 0 15px;
        border-bottom: 1px solid #ede8e4;
    }

    &__tooltip {
        background-color: #fff;
        border: 1px solid #ede8e4;
        color: #706c69;
        font-size: 12px;
        padding: 15px;
        position: relative;
        float: left;
        width: calc(100% - 90px);

        &:after,
        &:before {
            right: 100%;
            top: 30%;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }

        &:after {
            border-color: rgba(242, 242, 242, 0);
            border-right-color: #fff;
            border-width: 8px;
            margin-top: -15px;
        }

        &:before {
            border-color: rgba(203, 203, 203, 0);
            border-right-color: #ede8e4;
            border-width: 9px;
            margin-top: -16px;
        }

        &.bottom {
            width: 100%;

            &:after,
            &:before {
                right: 90%;
                top: 0;
                border: solid transparent;
                content: ' ';
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
            }

            &:after {
                border-color: rgba(242, 242, 242, 0);
                border-bottom-color: #fff;
                border-width: 9px;
                margin-top: -16px;
            }

            &:before {
                border-color: rgba(203, 203, 203, 0);
                border-bottom-color: #ede8e4;
                border-width: 9px;
                margin-top: -18px;
            }
        }
    }
}

.calendar__info__date__wrapper {
    border: 1px solid #ede8e4;
    text-align: center;
    width: 60px;
    float: left;
    margin-right: 30px;

    &--gray {
        background-color: #ede8e4;

        & > .calendar__info__month {
            background: #fff;
        }
    }
}

.calendar__info__date {
    background-color: #cf004a;
    color: white;
    padding: 5px;
}

.calendar__info__month {
    background-color: #fff;
    color: #67635f;
    font-size: 12px;
    font-weight: 700;
    padding: 5px;
}

.date__day-number {
    font-size: 32px;
    font-weight: 700;
    display: block;
    line-height: 26px;
}

.last-examination__section {
    display: flex;
    justify-content: space-between;
}

.app-box {
    border: 1px solid #ede8e4;
    display: flex;
    flex: 1 1;
    padding: 0 20px;
    justify-content: space-between;
    text-align: center;
    align-items: center;
}

.app-box--content {
    padding: 20px;
}

.next-examination__legend {
    float: left;
    width: 45px;
    height: 45px;
    background-color: #0e9604;
    border: 1px solid #0e9604;
    border-radius: 0;
    margin-right: 30px;

    &--transparent {
        background: none;
        border: none;
        margin-right: 15px;
    }
}

.legend-img {
    width: 45px;
}

.next-examination__date {
    float: left;
    font-size: 30px;
    font-weight: 700;

    .trigger {
        font-size: 14px;
        font-weight: 700;
        display: block;
    }
}

.first-period-day {
    background-color: red;
    color: #de5;
}

.radio__wrapper {
    float: left;
    width: 200px;

    .input-group {
        display: inline-flex;
        width: 70px;
    }
}

.activation-code-error {
    position: absolute;
    top: -30px;
    width: 60%;
}

@media (max-width: 1200px) {
    .activation-code-error {
        width: 70%;
    }
}

@media (max-width: 991px) {
    .app-box {
        justify-content: space-around;
    }

    .last-examination__wrapper {
        margin-bottom: 30px;
    }

    .activation-code-error {
        font-size: 16px;
        width: 100%;
    }
}

.btn-hover-disable {
    opacity: 0.6;

    &:hover {
        border-color: #cdc9c6;
        color: #222222;
    }
}
</style>



// WEBPACK FOOTER //
// my-account.vue?1a4a2319